<template>
  <div>
    <label>
      <ToggleButton v-model="model"> </ToggleButton>
    </label>
  </div>
</template>

<script>
import ToggleButton from "../../ToggleButton/ToggleButton.vue";
export default {
  name: "status",
  components: {
    ToggleButton,
  },
  data() {
    return {
      model: 1,
    };
  },
  props: ["input", "form", "value"],
  created() {
    this.model = Number(this.value);
  },
  watch: {
    form() {
      if (this.form) {
        this.model = 1;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model,
      });
    },
  },
};
</script>

<style></style>
